import './taxDeductionBanner.scss';

import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { KiaContext } from '../../../common/context/main.context';

export default function TaxDeductionBanner() {
  const { isB2c, country } = useContext(KiaContext);

  if (isB2c || country?.id === 'lu') {
    return null;
  }

  return (
    <div className="tax-deduction-banner">
      <p>
        <FormattedMessage
          id="tax.deduction.banner"
          values={{ note: <sup>(3)</sup> }}
        />
      </p>
    </div>
  );
}
